import { render } from "./LostItems.vue?vue&type=template&id=59526dc6"
import script from "./LostItems.vue?vue&type=script&lang=js"
export * from "./LostItems.vue?vue&type=script&lang=js"

import "./LostItems.vue?vue&type=style&index=0&id=59526dc6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__